import { tWithKeyAttr as t } from "../../i18nHelper";
import managementStyles from "./management.module.css";
import { Link, useNavigate } from "react-router-dom";
import { Dispatch, SetStateAction } from "react";
import { ISubCategory, ManagementCategories } from "../../types/types";
import { managementCategories } from "../../utils/categories";
import { useAppSelector } from "../../services/hooks";
import { adminSelector } from "../../services/selectors/user.selectors";
import { superAdminOptions } from "../../utils/user";

function Management({
  setProfileCategory,
}: {
  setProfileCategory?: Dispatch<SetStateAction<ISubCategory>>;
}) {
  const admin = useAppSelector(adminSelector);
  const navigate = useNavigate();
  const isFakeCompanyAdmin = admin.fakeCompanyId !== null && admin.fakeCompanyId !== undefined;

  return (
    <section className={`menuSection`} data-testid="management-section">
      <ul className={`options`}>
        <Link
          to="/jobs"
          className={`option hover`}
          data-testid={`management-jobs-button`}
        >
          {t("JOBS")}
        </Link>
        {isFakeCompanyAdmin ? null : (
          <>
        <Link
          to="/faq"
          className={`option hover`}
          data-testid={`management-faq-button`}
          onClick={() =>
            setProfileCategory?.(managementCategories[ManagementCategories.Faq])
          }
        >
          {t("MANAGEMENT_FAQ")}
        </Link>
        <Link
          to="/specializations"
          className={`option hover`}
          data-testid={`management-fields-of-specialization-button`}
          onClick={() =>
            setProfileCategory?.(managementCategories[ManagementCategories.Faq])
          }
        >
          {t("FIELDS_OF_SPECIALIZATION")}
        </Link>
        <Link
          to="/treatment_rooms"
          className={`option hover`}
        >
          {t("TREATMENT_ROOMS")}
        </Link>
        <Link
          to="/treatment_groups"
          className={`option hover`}
        >
          {t("TREATMENT_GROUPS")}
        </Link>
        <Link
          to="/table_permissions"
          className={`option hover`}
          data-testid={`management-table-permissions-button`}
        >
          {t("THERAPIST_TABLE_PERMISSIONS")}
        </Link>
        <Link
          to="/sms_fill_alerts"
          className={`option hover`}
          data-testid={`management-sms-fill-alerts-button`}
        >
          {t("SMS_FILL_ALERTS")}
        </Link>
        <Link
          to="/updates"
          className={`option hover`}
          data-testid={`management-updates-button`}
        >
          {t("ADMIN_UPDATES")}
        </Link>
        <Link
          to="/prices"
          className={`option hover`}
          data-testid={`management-prices-button`}
        >
          {t("SERVICE_PRICES")}
        </Link>
        {/* <Link
          to="/plans"
          className={`option hover`}
          onClick={() =>
            setProfileCategory?.(
              managementCategories[ManagementCategories.Plans]
            )
          }
        >
          {t('MANAGEMENT_PLANS')}</Link> */}

        {admin.roleId === -1 &&<Link
          to="/plans"
          className={admin.roleId === -1 ? "option hover" : "option button_disabled"}
          data-testid={`management-subscriptions-button`}
          onClick={admin.roleId === -1 ? () =>
            setProfileCategory?.(
              managementCategories[ManagementCategories.Plans]
            ) : (e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {t("MANAGEMENT_PLANS")}
        </Link>}

        {/* <Link
          to="/myAccount"
          className={`option hover`}
          onClick={() =>
            setProfileCategory?.(
              managementCategories[ManagementCategories.Settings]
            )
          }
        >
          {t('MY_ACCOUNT')}</Link> */}
        <Link
          to="/myAccount"
          className={`option hover`}
          data-testid={`management-my-account-button`}
          onClick={() =>
            setProfileCategory?.(
              managementCategories[ManagementCategories.Settings]
            )
          }
        >
          {t("MY_ACCOUNT")}
        </Link>

        <Link
          to="/companySettings"
          className={`option hover`}
          data-testid={`management-company-settings-button`}
          onClick={() =>
            setProfileCategory?.(
              managementCategories[ManagementCategories.Settings]
            )
          }
        >
          {t("COMPANY_SETTINGS")}
        </Link>


        {admin.roleId === -1 &&
          superAdminOptions.map((op) => (
            <li
              key={op.value}
              className={`option hover`}
              data-testid={`management-${op.value}-button`}
              onClick={() => navigate(op.path)}
            >
              {t(op.text)}
            </li>
          ))}
        {admin.roleId === -1 && (
          <Link
            to="/language"
            className={`option hover`}
            data-testid={`management-languages-button`}
            onClick={() =>
              setProfileCategory?.(
                managementCategories[ManagementCategories.Settings]
              )
            }
          >
            {t("LANGUAGES_MANAGEMENT")}
          </Link>
        )}
        {admin.roleId === -1 && (
          <Link
            to="/meeting-recording-config"
            className={`option hover`}
            data-testid={`management-meeting-recording-config-button`}
          >
            {t("MEETING_RECORDING_CONFIG")}
          </Link>
        )}
        {admin.roleId === -1 && (
          <Link
            to="/integrations"
            className={`option hover`}
            data-testid={`management-integrations-button`}
          >
            {t("INTEGRATIONS")}
          </Link>
        )}
        {admin.roleId === -1 && (
          <Link
            to="/audit-log"
            className={`option hover`}
            data-testid={`management-audit-log-button`}
          >
            {t("AUDIT_LOG")}
          </Link>
        )}
        {admin.roleId === -1 && (
          <Link
            to="/external-services"
            className={`option hover`}
            data-testid={`management-external-services-button`}
          >
            {t("MENU_EXTERNAL_SERVICES")}
          </Link>
        )}
          </>
        )}
      </ul>
    </section>
  );
}

export default Management;
